import React from 'react'
import finaerDesktopImage from '../../media/clients/finaer-desktop-project.webp'
import { SOFTWARE_SERVICES_PATH } from '../../routes'
import Project from '../../components/Project'
import { otherProjectsWithout } from '../otherProjectsCardsInformation'

export default class FinaerProject extends React.Component {
    name(){
        return 'finaer'
    }

    service(){
        return 'softwareDevelopment'
    }

    texts() {
        return this.props.texts
    }

    solutionsTexts() {
        return this.texts()['solutions']
    }

    image() {
        return this.props.image
    }

    otherProjects() {
        return otherProjectsWithout(this.name(),
            this.service(), this.solutionsTexts())
    }

    render() {
        return (
            <Project
                texts={this.texts()}
                image={this.image()}
                projectImg={finaerDesktopImage}
                otherProjects={this.otherProjects()}
                projectAreaPath={SOFTWARE_SERVICES_PATH}
            />
        )
    }
}
